import React, { useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button, CircularProgress, Typography, Box, Paper } from '@material-ui/core';
import { registerAuth0 } from './redux/actions';
import { useAuth0 } from '@auth0/auth0-react';

// mapDispatchToProps
const mapDispatchToProps = {
  dispatchRegisterAuth0: registerAuth0,
};

// connector
const connector = connect(null, mapDispatchToProps);
type I_props = ConnectedProps<typeof connector>;

function Auth0Register({ dispatchRegisterAuth0 }: I_props) {
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const {
    isAuthenticated,
    loginWithPopup,
    getAccessTokenSilently,
    error,
  } = useAuth0();

  const handleRegister = async () => {
    setLoading(true);

    try {
      // Trigger Auth0 login
      await loginWithPopup();

      // Wait until Auth0 marks the user as authenticated
      const token = await getAccessTokenSilently();
      localStorage.setItem("X-Custom-Auth", token);

      // Dispatch your registration action now
      dispatchRegisterAuth0(history);
    } catch (err) {
      console.error('Registration error:', err);
      alert('Registration failed. Please contact support.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      minHeight="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bgcolor="#f9f9f9"
    >
      <Paper elevation={3} style={{ padding: '2rem', textAlign: 'center', minWidth: 300 }}>
        <Typography variant="h5" gutterBottom>
          Register to Get Started
        </Typography>
        <Typography variant="body2" gutterBottom>
          Click the button below to register using your Auth0 account.
        </Typography>

        {loading ? (
          <CircularProgress style={{ marginTop: 16 }} />
        ) : (
          <Button
            variant="contained"
            color="primary"
            onClick={handleRegister}
            style={{ marginTop: 16 }}
            fullWidth
          >
            Register with Auth0
          </Button>
        )}

        {error && (
          <Typography color="error" style={{ marginTop: 16 }}>
            {error.message}
          </Typography>
        )}
      </Paper>
    </Box>
  );
}

export default connector(Auth0Register);
